<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Resultados</p>
        </header>
        <section class="modal-card-body">
          <div class="box">
            <div v-for="(question) in questions" :key="question.id">
							<p style="margin-bottom: 1em" v-html="question.question"></p>
							<div v-for="alternative in question.alternatives" :key="alternative.id">
								<span>{{alternative.alternative.alternative}}</span>
								<div class="columns">
									<div class="column is-9">
										<progress class="progress is-primary" :value="(alternative.counter*100)/question.counter" max="100">50%</progress>
									</div>
									<div class="column is-3">
										<b>{{((alternative.counter*100)/(question.counter)).toFixed(2)}}%</b> ({{alternative.counter}})
									</div>
								</div>
							</div>
              <div>{{question.type_selection_id}}</div>
              <p style="margin-bottom: 1em; margin-top: 1em;">
                Total respuestas: {{showTotalResponses(question.userQuestionaries)}} - Usuarios sin responder: {{totalFunctionaries - showTotalResponses(question.userQuestionaries)}} - De un total de: {{totalFunctionaries}}
              </p>
						</div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { getStablishments } from "../../../services/stablishment";
import { getFindByStablishment } from "../../../services/location";
import { getFindByQuestionarieId } from "../../../services/question_location";
import { getAnswersByQuestionry } from "../../../services/answer";
import { getQuestionarie } from "../../../services/questionarie";

export default {
  props: ["closeBasic", "isComponentModalActive", "questionary_id"],
  data() {
    return {
      isLoading: false,
      listStablishment: [],
      listLocation: [],
      listUsers: [],
      stablishment_id: "",
      location_id: "",
      loading: false,
      isFullPage: true,
      isPaginated: true,
      loadingTable: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
      answers: [],
			results: {},
			questions: [],
			totalFunctionaries: 0
    };
  },
  mounted: async function () {
		// this.chargeStablishments();
		let loader = this.$buefy.loading.open();
    this.answers = await getAnswersByQuestionry(this.$http, this.questionary_id); 
		let questionary = await getQuestionarie(this.$http, this.questionary_id);
		for (let i=0; i < questionary.questionaries_locations.length; i++) {
			let usersLocations = await getFindByQuestionarieId(this.$http, this.questionary_id, questionary.questionaries_locations[i].location_id);
			if (usersLocations) {
        console.log(usersLocations);
				this.totalFunctionaries = usersLocations.location.stablishment.users.length - 1;
			}
		}
		let questionaryQuestions = questionary.questions;
		console.log(questionaryQuestions)
		let response = questionaryQuestions.map(question => {
			console.log(question);
			let q = question.questions_alternatives.map(alternative => {
				return {
					...alternative,
					counter: 0
				}
			})
			console.log(q);
			return {
				...question,
				alternatives: q,
				counter: 0
			}
		});
		this.questions = response.map(value => ({
      ...value,
      userQuestionaries: []
    }));
		console.log(response);
		this.calculateResults();
		loader.close();
  },

  methods: {
    showTotalResponses(responses) {
      return responses.filter((value, index, self) => self.indexOf(value) === index).length;
    },
    calculateResults() {
			this.answers.forEach(answer => {
				this.questions.forEach((question, index) => {
					console.log('sddjs');
					//es la pregunta
					if (question.id == answer.alternative.questions_alternatives[0].question_id) {
						this.questions[index] = {
							...this.questions[index],
              userQuestionaries: [...this.questions[index].userQuestionaries, answer.user_questionary_id],
							counter: this.questions[index].counter + 1
						}
						console.log('sumar pregunta');
						//es la alternativa
						this.questions[index].alternatives.forEach((alternative, indexAlternative) => {
							if (answer.alternative_id == alternative.alternative_id) {
								this.questions[index].alternatives[indexAlternative] = {
									...this.questions[index].alternatives[indexAlternative],
									counter: this.questions[index].alternatives[indexAlternative].counter + 1
								}
								console.log('sumar alternativa');
							}
						})
					}
				})
			})
			console.log(this.questions)
    },
    async chargeStablishments() {
      this.isLoading = true;
      this.loading = true;
      await getStablishments(this.$http).then((response) => {
        this.listStablishment = response;
        this.loading = false;
        this.isLoading = false;
      });
    },
    async chargeLocation(id) {
      this.loading = true;
      this.listLocation = [];
      await getFindByStablishment(this.$http, id).then((response) => {
        this.listLocation = response;
        this.loading = false;
      });
    },
    async chargeUser(location_id) {
      this.loadingTable = true;
      this.listUsers = [];
      await getFindByQuestionarieId(
        this.$http,
        this.questionary_id,
        location_id
      ).then((response) => {
        if (response) {
          this.listUsers = response.location.stablishment.users;
        } else {
          this.listUsers = [];
        }
        this.loadingTable = false;
      });
    },
    // showResult(){
    //     this.$buefy.modal.open({
    //     parent: this,
    //     component: showResult,
    //     props: {
    //
    //     },
    //     hasModalCard: true,
    //     trapFocus: true,
    //   });
    // }
  },
};
</script>